import { useRouter } from 'vue-router'

export type Navigate = (event: MouseEvent) => Promise<unknown>

// Vue 2 reported a link click once the route had changed, so the event carries the destination's
// location while the page context still describes where the click came from. A click the router
// leaves to the browser, such as one opening a new tab, never changes the route and is sent as it ends.
export function useSendOnArrival() {
  const router = useRouter()

  async function followLinkThenSend(navigate: Navigate, event: MouseEvent, send: () => void) {
    let isSent = false
    const sendOnce = () => {
      if (isSent) return
      isSent = true
      send()
    }
    const removeHook = router.afterEach(sendOnce)
    await navigate(event)
    removeHook()
    sendOnce()
  }

  return { followLinkThenSend }
}
